import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component GitMergeIcon
 * @description
 * Outline git merge glyph for source-control signifiers. Matches
 * GitPullRequestIcon, but the incoming branch runs as a connector line into
 * the upper-left node instead of ending in an arrowhead, signifying a merge.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string applied to the stroke.
 *
 * @see https://design.activecollab.com/docs/foundations/icons
 */
const GitMergeIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="GitMergeIcon"
      fill="none"
      stroke={
        gradient
          ? "url(#icon-gradient)"
          : props?.stroke
          ? props.stroke
          : "var(--color-theme-600)"
      }
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path d="M7 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M7 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M17 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M7 8v8" />
      <path d="M9 6h4a4 4 0 0 1 4 4v6" />
    </svg>
  )
);
GitMergeIcon.displayName = "GitMergeIcon";
export default GitMergeIcon;
